import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=9f04de7c"
import script from "./FloatingButton.vue?vue&type=script&lang=js"
export * from "./FloatingButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingButton.vue?vue&type=style&index=0&id=9f04de7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports